import React from "react";

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  theme?: "black" | "white"; // Consider restricting theme values
}

export const TextInput: React.FC<TextInputProps> = ({
  error,
  theme = "black", // Set a default theme
  children,
  ...props
}) => {
  return (
    <div
      className={`w-full flex flex-col justify-start space-y-1 ${
        theme === "black" ? "text-black" : "text-white"
      }`}
    >
      {children}

      <div className="relative">
        <input
          type={props.type || "text"}
          className={`w-full focus:outline-none border rounded-lg px-4 py-3 text-base
            ${theme === "black"
              ? `${props.disabled ? "bg-[#f2f2f2]" : "bg-transparent"} border-main`
              : "text-white bg-transparent border-white"
            }
            ${error ? "border-red-600" : ""}
            ${props.disabled ? "cursor-not-allowed opacity-60" : ""}
            transition-colors duration-200
            focus:ring-2 focus:ring-opacity-50
            ${theme === "black" ? "focus:ring-main" : "focus:ring-white"}
            placeholder:text-gray-400
            sm:text-sm
          `}
          {...props}
        />
      </div>

      <div className="min-h-[1rem]">
        {error && (
          <div className="text-xs text-red-600 mt-1 animate-fade-in">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};